import { checkDataLayer } from '../../shared/general/tracking/TrackingService'

export default (toolName : string, toolId : string) => {
  window.TRACKING_TOOLS.set(toolName, {
    required_cookie_settings: toolName,
    initTracking () {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      })
      const f = document.getElementsByTagName('script')[0]
      const j = document.createElement('script')
      j.async = true
      j.src = `https://www.googletagmanager.com/gtm.js?id=${toolId}`
      f.parentNode?.insertBefore(j, f)
      checkDataLayer()
    },
  })
}
